import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { FORM_LEVEL_ERRORS } from '@shared/constants/constants';
import { HelperService } from '@shared/services/helper.service';
import { chain, every, isArray, startCase } from 'lodash';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-form-helper',
  templateUrl: './helper-form.component.html',
  styleUrls: ['./helper-form.component.scss'],
})
export class HelperFormComponent implements OnInit, OnDestroy {
  hasView: boolean;
  subscriptions = new Subscription();

  @Input() form: UntypedFormGroup | UntypedFormGroup[];

  constructor(private helperService: HelperService) {}

  ngOnInit() {
    const viewObserver = this.helperService.onFormHelpChange.subscribe(
      (hasView) => (this.hasView = hasView)
    );
    this.subscriptions.add(viewObserver);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  onClose(): void {
    this.helperService.hideFormHelp();
  }

  get isAllFormValid(): boolean {
    return every(this.form, (form: UntypedFormGroup) => form?.valid);
  }

  get errorFields(): any[][] {
    return this.forms.map((form: UntypedFormGroup) =>
      chain(form?.controls)
        .map((control: UntypedFormControl, controlName: string) =>
          control?.invalid ? startCase(controlName) : false
        )
        .filter((name: any) => name)
        .value()
    );
  }

  get formErrors(): any[] {
    return chain(this.forms)
      .flatMap((form: UntypedFormGroup) =>
        chain(form?.errors)
          .map((error, controlName: string) => (error ? FORM_LEVEL_ERRORS[controlName] : false))
          .filter((error) => error)
          .value()
      )
      .value();
  }

  private get forms(): UntypedFormGroup[] {
    return isArray(this.form) ? this.form : [this.form];
  }
}
